export class LoginUser {
    constructor(public UT?, public Name?, public UN?, public Pwd?, public DID?, public STID?, public ScID?, public STN?, public ScN?, public DN?, public Email?, public DPh?, public UserName?) { }
}